const a = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" role="presentation" aria-hidden="true"><path d="M7.47 4.72a.75.75 0 0 1 1.06 0l1.788 1.788c.41.41.41 1.074 0 1.484L8.53 9.78a.75.75 0 0 1-1.06-1.06L8.19 8H5a.75.75 0 0 1 0-1.5h3.19l-.72-.72a.75.75 0 0 1 0-1.06M13 6.5A.75.75 0 0 0 13 8h6a.75.75 0 0 0 0-1.5zm-8 10A.75.75 0 0 0 5 18h14a.75.75 0 0 0 0-1.5zm0-5A.75.75 0 0 0 5 13h14a.75.75 0 0 0 0-1.5z"/></svg>';
export {
  a as w
};
